import http from "@/services/http";

const search = (params) => http.get(`economic-group/search-group`, { params: params })

// Dados do Tomador
const getEconomicGroupFromCnpj = (cnpj) => http.get(`economic-groups/from-cnpj/${cnpj}`)
const storeEconomicGroup = (economicGroup) => http.post('economic-groups', economicGroup)
const updateEconomicGroup = (economicGroupId, params) => http.put(`economic-groups/${economicGroupId}`, params)

// Dados Bancários
const getBankDetail = (economicGroupId) => http.get(`economic-groups/${economicGroupId}/bank-details`)
const storeEconomicGroupBank = (economicGroupId, params) => http.post(`economic-groups/${economicGroupId}/bank-details`, params)

// Grupo econômico
const getEconomicGroupCompanies = (economicGroupId) => http.get(`economic-groups/${economicGroupId}/companies`)

// Corretoras
const getEconomicGroupBrokerInsuranceTypes = (economicGroupId) => http.get(`economic-groups/${economicGroupId}/broker-insurance-types`)
const storeEconomicGroupBrokerInsuranceTypes = (economicGroupId, params) => http.post(`economic-groups/${economicGroupId}/broker-insurance-types`, params)
const deleteEconomicGroupBroker = (economicGroupId, brokerId) => http.delete(`economic-groups/${economicGroupId}/broker-insurance-types/${brokerId}`)
const getEnabledInsurers = (economicGroupId) => http.get(`economic-groups/${economicGroupId}/insurers-enabled`)

// Observações
const getEconomicGroupObservations = (economicGroupId) => http.get(`economic-groups/${economicGroupId}/observations`)

// Seguradoras
const getEconomicGroupInsurerConfigurations = (economicGroupId) => http.get(`economic-groups/${economicGroupId}/insurer-configurations`)
const toogleInsurerEnabled = (economicGroupId, insurerIdentifier) => http.put(`economic-groups/${economicGroupId}/toogle-enabled-insurer/${insurerIdentifier}`)
const storeInsurerConfiguration = (economicGroupId, params) => http.post(`economic-groups/${economicGroupId}/insurer-configurations`, params)

//  Quiver
const getEconomicGroupQuiverConfigurations = (economicGroupId) => http.get(`economic-groups/${economicGroupId}/quiver-configurations`)
const storeQuiverConfiguration = (economicGroupId, params) => http.put(`economic-groups/${economicGroupId}/quiver-configurations`, params)

export default {
  search,
  getEconomicGroupFromCnpj,
  storeEconomicGroup,
  updateEconomicGroup,
  getBankDetail,
  storeEconomicGroupBank,
  getEconomicGroupCompanies,
  getEconomicGroupBrokerInsuranceTypes,
  storeEconomicGroupBrokerInsuranceTypes,
  deleteEconomicGroupBroker,
  getEnabledInsurers,
  getEconomicGroupObservations,
  getEconomicGroupInsurerConfigurations,
  toogleInsurerEnabled,
  storeInsurerConfiguration,
  getEconomicGroupQuiverConfigurations,
  storeQuiverConfiguration,
}
